<template>
    <div class="home" >

        <div class="card" v-if="info">
            <div class="card-container">
                <div class="title">官塘镇自来水缴费</div>
                <div class="center"></div>
                {{member?member.name:''}}
                <div class="no">{{member?member.NO:'未绑定'}}</div>
                <i v-if="isLoading" @click="go('bind')" class="iconfont bind"></i>
                <i v-if="isLoading" @click="selectDialog=true" class="iconfont toggle"></i>
            </div>
        </div>

        <div class="select-container"  v-if="selectDialog" @click="selectDialog=false">

            <div class="select-block" >
                <div v-if="!info.member" style="padding: 2vw;text-align: center">请先绑定用户</div>
                <div class="select-block-list" style="overflow: auto;">
                    <div class="select-item" @click="selectMember(item)"  :class="{selected:member.id===item.id}" style="padding: 4vw 0;border-bottom: 1px solid #e5e5e5;position: relative;padding: 4vw"
                         v-for="item in info.member">{{item.name}} <span>{{item.NO}}</span>
                        <i  style="right: 14vw" class="iconfont toggle1"></i>
                        <i @click.stop='unbind(item)' style="position: absolute;right: 4vw;bottom: 2.2vw;font-size: 7vw" class="icon-close"></i></div>
                </div>
            </div>

        </div>

        <div class="menu-card" v-if="isLoading">

            <div class="menu-container">


                <div v-if="member" @click="go('fee')" class="item">
                    <span>开始缴费</span>
                    <span class="iconfont icon-arrowright icon"></span>
                </div>

                <div v-if="!member" @click="go('bind')" class="item">
                    <span>开始绑定</span>
                    <span class="iconfont icon-arrowright icon"></span>
                </div>

                <div v-if="member" @click="go('history')" class="item">
                    <span>历史缴费记录</span>
                    <span class="iconfont icon-arrowright icon"></span>
                </div>

            </div>

        </div>


    </div>


</template>

<script>
    import {setToken} from "../utils/auth";
    import {getInfo, unbindMember} from "../api/api";

    export default {
        name: 'home',
        data() {
            return {
                selectDialog:false,
                isLoading:false,
                member: ''
                ,info:[]
            }
        }, methods: {
            unbind(item){
                // this.$toast({
                //     message: '解除绑定功能实现中',
                //     position: 'bottom',
                //     duration: 5000
                // })
                this.$msgbox.confirm('确定解除绑定?').then(action => {

                    unbindMember({id:item.id}).then(res=>{

                        this.$toast({
                            message: '解绑成功',
                            position: 'bottom',
                            duration: 5000
                        })
                        sessionStorage.removeItem('select')
                        setTimeout(()=>{
                            location.reload();
                        },1000)

                    })


                });


                // console.log(item);
            },
            selectMember(item) {

                sessionStorage.setItem('select',JSON.stringify(item));
                this.member = item;
                this.$toast({
                    message: '切换成功',
                    position: 'bottom',
                    duration: 5000
                })
            },
            _getInfo() {

                getInfo().then(res => {

                    if (res.data.member.length > 0) {
                        this.info = res.data;
                        if (!sessionStorage.getItem('select')) {
                            sessionStorage.setItem('select',JSON.stringify(res.data.member[0]));
                        }
                        this.member = JSON.parse(sessionStorage.getItem('select'));
                        // console.log(res.data.member[0])
                    }
                    this.isLoading = true;
                })

            }
            , go(type) {

                if (type === 'fee') {
                    this.$router.push({
                        path: '/fee'
                    });
                }

                if (type === 'history') {
                    this.$router.push({
                        path: '/history'
                    });
                }

                if (type === 'bind') {
                    this.$router.push({
                        path: '/bind'
                    });
                }

            }
        }, created() {

            this._getInfo();

        }
    }
</script>

<style scoped lang="less">

    .home {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 4vw 4vw;
        background-color: #f3f3f3;
    }

    .card {
        display: flex;
        border-radius: 10px;
        /*background-image: linear-gradient(-30deg,#00B4DB,#0083B0);*/
        color: #fff;
        height: 54vw;
        background: #00d2ff;
        background: -webkit-linear-gradient(30deg, #3a7bd5, #00d2ff);
        background: linear-gradient(30deg, #3a7bd5, #00d2ff);
        box-shadow: 1px 1px 12px rgba(0, 0, 0, 0.2);

    }

    .card .card-container {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 2vw 4vw;
    }

    .card .title {
        font-size: 5vw;
        /*padding: ;*/
    }

    .card-container .center {
        flex: 1;
    }

    .card-container .no {

    }

    .menu-card {
        margin-top: 5vw;
        background-color: #fff;
        box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.05);
        border-radius: 5px;
    }

    .menu-card .menu-container {
        padding: 0 2vw;
    }

    .menu-container .item {
        font-size: 4.5vw;
        padding: 4vw 0;
        line-height: 5vw;
        border-bottom: 1px #e5e5e5 solid;
        display: flex;
        color: #394543;
    }

    .menu-container .item .icon {
        flex: 1;
        text-align: right;
    }

    .menu-container .item:last-child {
        border-bottom: none;
    }

    .iconfont.bind {
        /*width: 5vw;*/
        position: absolute;
        bottom: 2vw;
        right: 14vw;
    }

    .iconfont.bind:after {
        content: '';
        display: inline-block;
        background-image: url("../assets/bind.png");
        background-size: cover;
        height: 8vw;
        width: 8vw;
    }
    .iconfont.toggle {
        /*width: 5vw;*/
        position: absolute;
        bottom: 2vw;
        right: 4vw;
    }



    .iconfont.toggle:after {
        content: '';
        display: inline-block;
        background-image: url("../assets/toggle.png");
        background-size: cover;
        height: 8vw;
        width: 8vw;
    }

    .iconfont.toggle1:after {
        content: '';
        display: inline-block;
        background-image: url("../assets/toggle1.png");
        background-size: cover;
        height: 6vw;
        width: 6vw;
    }
    .iconfont.toggle1 {
        /*width: 5vw;*/
        position: absolute;
        bottom: 2.2vw;
        right: 4vw;
    }

    .select-container{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.12);

    }

    .select-block{
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -40vw;
        margin-left:-40vw;
        height: 80vw;
        width: 80vw;
        background-color: #fff;
        border-radius: 10px;
        overflow: hidden;
        display: flex;
        flex-direction: column;

    }

    .select-block .select-block-list {
        overflow: auto;
        -webkit-overflow-scrolling: touch;
    }

    .select-item:last-child {
        border-bottom: none!important;
    }

    .select-item.selected {
        background-color: #35c0ff;
        color: #fff;
    }

    .selected .iconfont.toggle1:after {
        content: '';
        display: inline-block;
        background-image: url("../assets/toggle.png");
        background-size: cover;
        height: 6vw;
        width: 6vw;
    }

</style>
